import React from 'react'

interface SearchProps {
  width: number;
  height: number;
  strokeWidth: number;
}
const Search: React.FC<SearchProps> = ({ width = 18, height = 17, strokeWidth = 2 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M14.4167 5.75L17.0833 8.41667L15.9167 9.58333L13.25 6.91667C12.9583 7.08333 12.6458 7.22222 12.3125 7.33333C11.9792 7.44444 11.625 7.5 11.25 7.5C10.2083 7.5 9.32292 7.13542 8.59375 6.40625C7.86458 5.67708 7.5 4.79167 7.5 3.75C7.5 2.70833 7.86458 1.82292 8.59375 1.09375C9.32292 0.364583 10.2083 0 11.25 0C12.2917 0 13.1771 0.364583 13.9062 1.09375C14.6354 1.82292 15 2.70833 15 3.75C15 4.125 14.9444 4.47917 14.8333 4.8125C14.7222 5.14583 14.5833 5.45833 14.4167 5.75ZM12.7292 5.22917C13.1319 4.82639 13.3333 4.33333 13.3333 3.75C13.3333 3.16667 13.1319 2.67361 12.7292 2.27083C12.3264 1.86806 11.8333 1.66667 11.25 1.66667C10.6667 1.66667 10.1736 1.86806 9.77083 2.27083C9.36806 2.67361 9.16667 3.16667 9.16667 3.75C9.16667 4.33333 9.36806 4.82639 9.77083 5.22917C10.1736 5.63194 10.6667 5.83333 11.25 5.83333C11.8333 5.83333 12.3264 5.63194 12.7292 5.22917ZM1.66667 16.6667C1.20833 16.6667 0.815972 16.5035 0.489583 16.1771C0.163194 15.8507 0 15.4583 0 15V3.33333C0 2.875 0.163194 2.48264 0.489583 2.15625C0.815972 1.82986 1.20833 1.66667 1.66667 1.66667H6.25C6.09722 2.01389 5.99306 2.37153 5.9375 2.73958C5.88194 3.10764 5.85417 3.47222 5.85417 3.83333C5.85417 5.34722 6.38889 6.61111 7.45833 7.625C8.52778 8.63889 9.79861 9.14583 11.2708 9.14583C11.5347 9.14583 11.7986 9.12847 12.0625 9.09375C12.3264 9.05903 12.5972 9 12.875 8.91667L15 11.0417V15C15 15.4583 14.8368 15.8507 14.5104 16.1771C14.184 16.5035 13.7917 16.6667 13.3333 16.6667H1.66667Z"
        fill="white"
      />
    </svg>
  );
};

export default Search;